/**
 *
 * @desc 个人中心 我的消息通用逻辑
 *
 **/
import { getlist, deleteMessage, markRead } from '@/api/personCenter/message';
import { postReadAll } from '&/api/personCenter/message';

export default function useMessage(type, updateUnread, forceUpdate) {
    const TABS = [
        intl.get('userCenter.interactiveMsg'),
        intl.get('userCenter.systemMsg'),
    ];

    const [msgList, setMsgList] = useState([]),
        [loading, setloading] = useState(false),
        [total, settotal] = useState(0),
        [queryForm, setQueryForm] = useState({
            page: 1,
            limit: 10,
            type,
        });

    useEffect(() => {
        queryMsgList();
    }, [queryForm, forceUpdate]);

    function queryMsgList() {
        setloading(true);
        getlist(queryForm)
            .then(({ data }) => {
                settotal(data.total);
                setMsgList(data.list);
            })
            .finally(() => {
                setloading(false);
            });
    }

    const onPageChange = (page, limit) => {
        setQueryForm(pre => ({ ...pre, page, limit }));
    };

    const deleteMsg = async (evt, id) => {
        evt.stopPropagation();
        await deleteMessage(id);
        queryMsgList();
        updateUnread();
    };

    const markAsRead = async (ids, status) => {
        if (status === 1) return;
        if (!ids) {
            await postReadAll();
            queryMsgList();
        } else {
            const [first] = ids;
            if (first === void 0) return;
            await markRead({
                ids,
            });
            setMsgList(prev => {
                const idx = prev.findIndex(e => e.id === first);
                const next = [...prev];
                next[idx].status = 1;
                return next;
            });
        }

        updateUnread();
    };

    return [
        TABS[type - 1],
        msgList,
        loading,
        total,
        queryForm,
        onPageChange,
        deleteMsg,
        markAsRead,
    ];
}
